module.exports = __webpack_public_path__ + "img/bgtop22.75b229ef.jpg";